import { dynamicLoader } from '~/utils';

export const PaymentsPage = dynamicLoader({
  name: 'PaymentsPage',
  importFunc: () => import('./payments'),
});